import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Ghost from '@/images/Ghost.svg';
import { DidUser } from '@/services/auth';
import { useGetAllFlags } from '@/services/featureFlags';
import theme from '@/theme';
import { isDidUser } from '@/utils/utils';
import styled from '@emotion/styled';
import { Modal } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { ListItemIcon, RedListItemText } from './components';

const RawDataContainer = styled.div`
    padding: 8px;
    overflow: auto;
    width: 50vw;
    height: 50vh;
    background: white;
    font-size: 16px;
    transform: translate(+50%, +50%);
`;

interface Props {
    dataToShow: any;
    closeMenu: () => void;
}

const RAW_DATA_ALLOWED_EMAIL_DOMAIN = ['appglide'];
export const shouldShowRawMenuItem = (user?: DidUser | undefined | null) => {
    return isDidUser(user?.email) || (user?.email && RAW_DATA_ALLOWED_EMAIL_DOMAIN.includes(user?.email));
};

export const RawDataMenuItem = ({ dataToShow, closeMenu }: Props) => {
    const [shouldShowModal, setShouldShowModal] = useState<boolean>(false);
    const featureFlags = useGetAllFlags();

    const data = {
        entity: dataToShow,
        featureFlags,
    };

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(JSON.stringify(data, null, 4));
    };

    const handleCopyEntityIdToClipboard = () => {
        navigator.clipboard.writeText(data.entity.id);
    };

    return (
        <MenuItem onClick={() => setShouldShowModal(true)}>
            <ListItemIcon>
                <MaskedIcon src={Ghost} size="24px" color={theme.colors.error.main} />
            </ListItemIcon>

            <RedListItemText>Show Raw Data</RedListItemText>

            <Modal
                open={shouldShowModal}
                onClose={() => {
                    setShouldShowModal(false);
                    closeMenu();
                }}>
                <RawDataContainer>
                    <button onClick={handleCopyToClipboard}>Copy to clipboard</button>
                    <button onClick={handleCopyEntityIdToClipboard} style={{ marginInlineStart: '.8rem' }}>
                        Copy id to clipboard
                    </button>
                    <pre>{JSON.stringify(data, null, 4)}</pre>
                </RawDataContainer>
            </Modal>
        </MenuItem>
    );
};
